/**
 * Routes that live outside the app's role/auth routing (RoleBasedRoutes,
 * PrivateRoute, onboarding/user-role redirects), for any visitor whether or
 * not an app session exists:
 *   - the Haire internal admin portal (ADMIN_BASE/*, own login), and
 *   - the public company preview from outreach emails (/company-preview/:token).
 */
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import RouteLoading from "../components/CommonComponents/RouteLoading";
import { ADMIN_BASE, isAdminPortalPath } from "../pages/HaireAdmin/adminPortalPath";

const HaireAdminPortal = React.lazy(() => import("../pages/HaireAdmin/HaireAdminPortal"));
const CompanyPreviewPage = React.lazy(() => import("../pages/CompanyPreview/CompanyPreviewPage"));
const OpenAsCompany = React.lazy(() => import("../pages/OpenAs/OpenAsCompany"));

const COMPANY_PREVIEW_RE = /^\/company-preview\/[^/]+\/?$/;

export const isStandalonePath = (pathname) =>
  isAdminPortalPath(pathname) ||
  COMPANY_PREVIEW_RE.test(String(pathname || "")) ||
  /^\/open-as\/?$/.test(String(pathname || ""));

export default function StandaloneRoutes() {
  return (
    <Suspense fallback={<RouteLoading />}>
      <Routes>
        <Route path={`${ADMIN_BASE}/*`} element={<HaireAdminPortal />} />
        {/* TODO(PRE-QAT): public company preview is not in PRE.
        <Route path="/company-preview/:token" element={<CompanyPreviewPage />} />
        */}
        {/* "Open as company" landing (admin portal -> new app tab) */}
        <Route path="/open-as" element={<OpenAsCompany />} />
      </Routes>
    </Suspense>
  );
}
